export const budgetsActions = {
  CLICK_BUDGETS_CREATE: "CLICK_BUDGETS_CREATE",
  CLICK_BUDGETS_DELETE: "CLICK_BUDGETS_DELETE",
  CLICK_BUDGETS_EXPORT: "CLICK_BUDGETS_EXPORT",
  CLICK_BUDGETS_UPDATE: "CLICK_BUDGETS_UPDATE",
} as const;
